// extracted by mini-css-extract-plugin
module.exports = {"navLink":"NavItem_navLink__GlRD7","active":"NavItem_active__1ptts","sidebarIcon":"NavItem_sidebarIcon__3Vzk8","iconWrapper":"NavItem_iconWrapper__2ZEQz"};